import { FriendInviteCreateVm } from "./domain";
import { ApiCallParams, apiPostWithDetailErrorResponse } from "../baseService";

export async function postInviteFriendDataApi(
  params: ApiCallParams<FriendInviteCreateVm>
) {
  const response = await apiPostWithDetailErrorResponse("/api/invites", {
    payload: params
  });

  return response.data;
}
